import { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import {
  AlertTriangle,
  ClipboardList,
  ArrowLeft,
} from 'lucide-react';

export default function TodoNavigationGuard() {
  const { user, pendingTasks, checkPendingTasks } = useAuth();
  const location = useLocation();

  // Refresh tasks when entering todos page
  useEffect(() => {
    if (location.pathname === '/todos' && (user?.role === 'recruiter' || user?.role === 'hr_manager')) {
      checkPendingTasks();
    }
  }, [location.pathname, user, checkPendingTasks]);

  // This component now only refreshes tasks on the todos page
  // The actual navigation blocking is handled through the logout confirmation
  return null;
}
